import Vue from 'vue'
import axios from 'axios'
// import qs from 'qs'
import {Message} from 'element-ui'
import store from '@/store'

// axios 配置
axios.defaults.timeout = 10000;
axios.defaults.baseUrl = 'http://114.255.48.111/'


const http = axios.create()

// http request 拦截器
http.interceptors.request.use(
    config => {
        let token = store.state.token || window.localStorage.getItem('token')||'';
        if (token) {
            config.headers['token'] = token
            config.headers['X-Requested-With'] = 'XMLHttpRequest'
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });
// http response 拦截器

http.interceptors.response.use(
    response => {
        if(response.data.code!=0){
            if (response.data.code == 10401) {
                Message.error('登录过期，请重新登录')
                setTimeout(() => {
                    store.dispatch('loginOut')
                }, 1000)
                return
            } else {
                return Promise.reject(response.data.msg);
            }
        } else {
            return response.data;
        }
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 202:
                    Message.error('报错了');break;
                case 201:
                    Message.error('报错了');break;
                case 500:
                    Message.error('服务端错误');break;
                case 404:
                    Message.error('找不到了');break;
                case 502:
                    Message.error('服务端错误');break;
            }
        }
    });

Vue.prototype.$http = http
export default http;
